import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SecurityChannelType } from 'utils/globalTypes';
import { SecurityChannels } from './types';
import { initialSecurityState } from './utils';

const securitySlice = createSlice({
  name: 'security',
  initialState: initialSecurityState,
  reducers: {
    setUserSecurityChannels(state, action: PayloadAction<SecurityChannels>) {
      state.channels = action.payload;
      state.isFetched = true;
    },
    updateUserSecurityChannel(
      state,
      action: PayloadAction<{ channel: SecurityChannelType; value: string }>,
    ) {
      const { channel, value } = action.payload;
      state.channels[channel] = value;
    },
    removeUserSecurityChannel(
      state,
      action: PayloadAction<SecurityChannelType>,
    ) {
      state.channels[action.payload] = '';
    },
  },
});

export const {
  setUserSecurityChannels,
  updateUserSecurityChannel,
  removeUserSecurityChannel,
} = securitySlice.actions;

export default securitySlice.reducer;
